import { render, staticRenderFns } from "./new_user_acquisition_rules.vue?vue&type=template&id=c45c2df4&scoped=true&"
import script from "./new_user_acquisition_rules.vue?vue&type=script&lang=js&"
export * from "./new_user_acquisition_rules.vue?vue&type=script&lang=js&"
import style0 from "./new_user_acquisition_rules.vue?vue&type=style&index=0&id=c45c2df4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45c2df4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c45c2df4')) {
      api.createRecord('c45c2df4', component.options)
    } else {
      api.reload('c45c2df4', component.options)
    }
    module.hot.accept("./new_user_acquisition_rules.vue?vue&type=template&id=c45c2df4&scoped=true&", function () {
      api.rerender('c45c2df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberCenter/views/activity_management/components/new_user_acquisition_rules.vue"
export default component.exports